import { RCA_STATUSES } from "constants/constants";
import { useStyles } from "./RCAStatusBadge.styles";
import { IRCAStatusBadge } from "./RCAStatusBadgeInterfaces";
import { useTheme } from "@mui/material/styles";
import { useMemo } from "react";

const statusClasses = {
    [RCA_STATUSES.NOT_STARTED]: 0,
    [RCA_STATUSES.DONE_25]: 25,
    [RCA_STATUSES.DONE_50]: 50,
    [RCA_STATUSES.DONE_75]: 75,
    [RCA_STATUSES.COMPLETED]: 100,
    [RCA_STATUSES.NEEDS_APPROVAL]: 100,
    [RCA_STATUSES.BLOCKED]: 100,
    [RCA_STATUSES.REJECTED]: 100,
};

const RCAStatusBadge = ({ status }: IRCAStatusBadge) => {
    const classes = useStyles();
    const theme = useTheme();

    const statusColors = useMemo(
        () =>
            ({
                [RCA_STATUSES.NOT_STARTED]: theme.palette.info.main,
                [RCA_STATUSES.DONE_25]: theme.palette.info.main,
                [RCA_STATUSES.DONE_50]: theme.palette.info.main,
                [RCA_STATUSES.DONE_75]: theme.palette.info.main,
                [RCA_STATUSES.COMPLETED]: theme.palette.success.main,
                [RCA_STATUSES.NEEDS_APPROVAL]: theme.palette.warning.dark,
                [RCA_STATUSES.BLOCKED]: theme.palette.error.main,
                [RCA_STATUSES.REJECTED]: theme.palette.error.main,
            } as Record<number, string>),
        [theme.palette.info.main, theme.palette.success.main, theme.palette.warning.dark, theme.palette.error.main],
    );

    return (
        <div className={classes.pie}>
            <div
                className={classes.pieBefore}
                style={{
                    border: `1px solid ${statusColors[status as keyof typeof statusColors]}`,
                    background: `conic-gradient(${statusColors[status as keyof typeof statusColors]} calc(${
                        statusClasses[status as keyof typeof statusClasses]
                    }*1%),#0000 0)`,
                }}
            />
        </div>
    );
};

export default RCAStatusBadge;
